import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { EventEmitter, Injectable, Input, Output } from "@angular/core";
import { MixinInjectorConstructor } from "./mixin";

export type FieldStateValue =
  | "enabled"
  | "hover"
  | "active"
  | "read-only"
  | "loading"
  | "disabled"
  | "invalid";

export const FieldStateMixin = <CLAZZ extends MixinInjectorConstructor>(Clazz: CLAZZ) => {
  @Injectable()
  abstract class FieldState extends Clazz {
    @Input()
    private _fieldState: FieldStateValue = "enabled";

    public get fieldState(): FieldStateValue {
      return this._fieldState;
    }
    public set fieldState(value: FieldStateValue) {
      this._fieldState = value;
    }

    @Output()
    public fieldStateChange = new EventEmitter<FieldStateValue>();
  }

  return FieldState;
};

export const FieldStateMixinInputs = ["fieldState"];
